<template>
  <div class="b1">
    <div class="bg"></div>
    <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
    <div class="body">
      <div class="center">
        <div class="c_input">
          <div>关键词</div>
          <input placeholder="请输入" v-model="keywords" />
        </div>
        <div class="c_input">
          <div>录入时间</div>
          <el-date-picker value-format="yyyy-MM-dd" v-model="dateList" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <el-button type="primary" size="small" plain @click="search">搜索</el-button>
        <el-button size="small" plain @click="reset">重置</el-button>
      </div>
      <div class="info" v-if="stuInfo && stuInfo.id">
        <img :src="webImg + stuInfo.avatar" />
        <div>{{ stuInfo.name }}的档案</div>
        <div>总数：{{ total }}</div>
      </div>
      <div class="tab">
        <div class="tb_left">
          <div class="tb_item" :class="type == 1 ? 'tbi' : ''" @click="btn_type(1)">教师评价记录</div>
          <div class="tb_item" :class="type == 2 ? 'tbi' : ''" @click="btn_type(2)">智能体评价记录</div>
        </div>
        <div class="tb_right">
          <div class="tb_item tbi" @click="$router.push({ path: '/stuArchivesList', query: { studentId: studentId } })">
            查看报告</div>
          <div class="tb_item" @click="btn_sc">生成报告</div>
        </div>
      </div>
      <div class="bottom">
        <el-table ref="multipleTable" :header-cell-style="{ background: '#F7F8FA' }" :data="list"
          @selection-change="handleSelectionChange" style="width: 100%;" :height="'100%'" v-show="type == 1">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="stuNo" label="序号">
            <template slot-scope="scope">
              <div>{{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="录入内容">
            <template slot-scope="scope">
              <div class="line5_" :title="scope.row.content">{{ scope.row.content }}</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="gender" label="分析结果"></el-table-column> -->
          <el-table-column prop="teacherName" label="录入老师"></el-table-column>
          <el-table-column prop="createTime" label="录入时间"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" plain @click="btn_del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-table ref="multipleTable" :header-cell-style="{ background: '#F7F8FA' }" :data="list"
          @selection-change="handleSelectionChange" style="width: 100%;" :height="'100%'" v-show="type == 2">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="stuNo" label="序号">
            <template slot-scope="scope">
              <div>{{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="helperName" label="智能体"></el-table-column>
          <el-table-column prop="evaluate" label="分析结果" width="500"></el-table-column>
          <el-table-column prop="subjectName" label="学科"></el-table-column>
          <el-table-column prop="teacherName" label="课堂老师"></el-table-column>
          <el-table-column prop="updateTime" label="生成时间" width="200">
            <template slot-scope="scope">
              <div>{{ getDateTime2(scope.row.updateTime) }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  dailyRecordList,
  studentInfo,
  classHelperStudentList,
  studentPersonalFileAdd,
  dailyRecordRemove
} from '@/apis/index'
export default {
  data() {
    return {
      type: 1,
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      keywords: '',
      dateList: ['',''],
      studentId: this.$route.query.studentId || '',
      stuInfo: {},
      arr: []
    }
  },
  mounted() {
    console.log(this.studentId, 'studentId');

    this.getList()
    this.getStudentInfo()
  },
  methods: {
    search(){
      this.pageNum = 1
      this.getList()
    },
    reset() {
      this.keywords = ''
      this.dateList = ['','']
      this.pageNum = 1
      this.getList()
    },
    btn_del(id) {
      this.$confirm('是否确定删除该记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        dailyRecordRemove(id).then(res => {
          console.log(res, 'dailyRecordRemove');
          this.pageNum = 1
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      })
    },
    btn_sc() {
      if (this.list.length == 0) {
        return this.$message.error('请选择要生成报告的数据')
      }
      var classHelperStudentIdList = []
      var dailyRecordIdList = []
      if (this.type == 1) {
        dailyRecordIdList = this.arr.map(item => item.id)
      } else {
        classHelperStudentIdList = this.arr.map(item => item.id)
      }
      studentPersonalFileAdd({
        classHelperStudentIdList: classHelperStudentIdList,
        dailyRecordIdList: dailyRecordIdList,
        studentId: this.studentId
      }).then(res => {
        console.log(res, 'studentPersonalFileAdd');
        // 系统正在生成中，请在2-3分钟后查看
        this.$alert('提交成功，AI正在生成中，请在2-3分钟后点击[查看报告]查看', '提示', {
          confirmButtonText: '确定'
        });
        // this.$message.success('生成成功，可点击[查看报告]去查看')
        this.$refs.multipleTable.clearSelection();
      })
    },
    btn_type(type) {
      this.type = type
      this.arr = []
      this.pageNum = 1
      this.getList()
    },
    getStudentInfo() {
      studentInfo(this.studentId).then(res => {
        console.log(res, 'studentInfo');
        this.stuInfo = res.data
      })
    },
    getList() {
      if (this.type == 1) {
        dailyRecordList(this.studentId, this.pageNum, this.pageSize, 2,this.keywords,this.dateList[0],this.dateList[1]).then(res => {
          console.log(res, 'dailyRecordList');
          if (this.pageNum == 1) {
            this.list = []
          }
          this.total = res.data.total
          this.list = res.data.list
        })
      } else {
        classHelperStudentList(this.studentId, this.pageNum, this.pageSize,this.keywords,this.dateList[0],this.dateList[1]).then(res => {
          console.log(res, 'classHelperStudentList');
          if (this.pageNum == 1) {
            this.list = []
          }
          this.total = res.data.total
          this.list = res.data.list
        })
      }
    },
    handleSelectionChange(e) {
      console.log(e, 'e');
      this.arr = e
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageNum = 1
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-range__icon {
    line-height: 20px !important;
  }

  .el-range-separator {
    line-height: 20px !important;
  }
  .el-range__close-icon{
    line-height: 20px !important;

  }
}

.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line2_ {
  word-break: break-all;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.b1 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  .bg {
    width: 100%;
    height: 228px;
    background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}

.back {
  width: 1200px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  // margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  box-sizing: border-box;

  img {
    width: 14px;
    height: 14px;

  }
}

.body {
  width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 20px;

  .tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;

    .tb_left,
    .tb_right {
      display: flex;
      align-items: center;
    }

    .tb_right {

      div {
        width: 104px !important;
      }
    }

    .tb_item {
      width: 204px;
      height: 38px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #399AFF;
      font-weight: bold;
      font-size: 16px;
      color: #399AFF;
      text-align: center;
      line-height: 38px;
      margin-right: 20px;
      cursor: pointer;
      user-select: none;
    }

    .tbi {
      background: #399AFF !important;
      color: #FFFFFF !important;
    }
  }

  .info {
    width: 100%;
    display: flex;
    align-items: center;
    // margin: 40px 0;
    margin-bottom: 40px;

    img {
      width: 50px;
      height: 50px;
      border-radius: 90px 90px 90px 90px;
      border: 1px solid #FFFFFF;
    }

    div:nth-child(2) {
      font-weight: bold;
      font-size: 20px;
      color: #000000;
      margin: 0 20px;
    }

    div:nth-child(3) {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
  }

  .center {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 40px 0;

    .c_input {
      display: flex;
      align-items: center;

      .el-range-editor {
        margin-left: 20px;
        width: 280px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #CED4DB;
        margin-right: 20px;

      }

      div {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }

      input {
        margin-left: 20px;
        width: 280px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #CED4DB;
        box-sizing: border-box;
        padding: 0 12px;
        margin-right: 20px;
      }
    }
  }

  .bottom {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
}
.line5_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
</style>
